<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
  import store from '@/store'
  import bus from '@/bus'
  export default {

      store,

      created(){

          bus.$on('setTitle',function (title) {

              if(title){
                  document.title = title;
              }

          })
      }


  }


</script>

<style>
  .detail img{

    max-width: 100%;
  }

</style>
